export default [
    {
        path: '/',
        name: 'home',
        component: () => import('VIEWS/Home.vue')
    }
]